// src/components/common/InheritanceDropdownItem.jsx
import React from 'react';
import PropTypes from 'prop-types';

const InheritanceDropdownItem = ({ 
  onClick, 
  isLoading = false, 
  loadingText = 'Adding...', 
  defaultText = 'Add to Endowment',
  disabled = false,
  className = "dropdown-item inherit-dropdown-item"
}) => {
  const handleClick = (e) => {
    if (isLoading || disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    onClick(e);
  };

  return (
    <button 
      className={className}
      onClick={handleClick}
      disabled={isLoading || disabled}
      style={{ 
        opacity: (isLoading || disabled) ? 0.6 : 1,
        cursor: (isLoading || disabled) ? 'not-allowed' : 'pointer',
        pointerEvents: (isLoading || disabled) ? 'none' : 'auto'
      }}
    >
      <i className={`fas ${isLoading ? 'fa-spinner fa-spin' : 'fa-child'} fa-sm fa-fw mr-2 text-black-400`}></i>
      {isLoading ? loadingText : defaultText}
    </button>
  );
};

InheritanceDropdownItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  loadingText: PropTypes.string,
  defaultText: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string
};

export default InheritanceDropdownItem;